<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">


            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->


            <div class="dashboard-container-right">
                <div class="main-container">
                    <div class="row">
                        <div class="card shadow custom-margin-right-box" style="width: 100%">
                            <div class="card-header ">
                                <h4>Add Sample Center User</h4>
                            </div>
                            <div class="card-body">

                                <div class="col-lg-12 ">

                                    <div class="card p-5 d-flex justify-content-center ">
                                        <form [formGroup]="addUserForm" (ngSubmit)="onSubmit(addUserForm.value)">
                                            <div class="row">

                                                <div class="col-md-6">
                                                    <label class="form-label">Name<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>

                                                    <input type="text" class="form-control" id="name"
                                                        formControlName="name" placeholder=""
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; addUserForm.controls.name.errors }">


                                                    <div *ngIf="submitted &amp;&amp; addUserForm.controls.name.errors"
                                                        class="form-text text-danger">
                                                        <div *ngIf="addUserForm.controls.name.errors.required">Name is
                                                            required</div>
                                                        <div *ngIf="addUserForm.controls.name.errors.maxlength">Name
                                                            must be under 45 characters
                                                        </div>
                                                        <div *ngIf="addUserForm.controls.name.errors.pattern">Name must
                                                            be only alphabets</div>
                                                    </div>

                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">Email Address<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input type="email" class="form-control"
                                                        formControlName="emailAddress" id="emailAddress"
                                                        aria-describedby="emailHelp"
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; addUserForm.controls.emailAddress.errors }"
                                                        placeholder="">
                                                    <div *ngIf="submitted &amp;&amp; addUserForm.controls.emailAddress.errors"
                                                        class="form-text text-danger">
                                                        <div *ngIf="addUserForm.controls.emailAddress.errors.required">
                                                            Email is required</div>
                                                        <div *ngIf="addUserForm.controls.emailAddress.errors.pattern">
                                                            Please enter a valid email
                                                        </div>
                                                        <div *ngIf="addUserForm.controls.emailAddress.errors.maxlength">
                                                            Email must be under 45
                                                            characters</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">Password<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input type="password" class="form-control" id="password"
                                                        maxlength="15" formControlName="password"
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; addUserForm.controls.password.errors }"
                                                        placeholder="">
                                                    <div *ngIf="submitted &amp;&amp; addUserForm.controls.password.errors"
                                                        class="form-text text-danger">
                                                        <div *ngIf="addUserForm.controls.password.errors.required">
                                                            Password is required</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">Confirm Password<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input type="password" class="form-control"
                                                        formControlName="confirmPassword" placeholder=""
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; addUserForm.controls.confirmPassword.errors }">
                                                    <div *ngIf="submitted &amp;&amp; addUserForm.controls.confirmPassword.errors"
                                                        class="form-text text-danger">
                                                        <div
                                                            *ngIf="addUserForm.controls.confirmPassword.errors.required">
                                                            Confirm Password is
                                                            required</div>
                                                    </div>
                                                </div>

                                                <div class="col-md-12 mt-5 text-center"><button type="submit"
                                                        class="btn p-2 btn-primary ">Submit
                                                    </button></div>



                                            </div>
                                        </form>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<app-footer-dashboard></app-footer-dashboard>